import { translations } from 'components/RteEditor/translations';
import { useLanguage } from 'components/RteEditor/Providers/LanguageProvider';

export const useTranslation = () => {
  const { currentLanguage } = useLanguage() as { currentLanguage: 'NL' | 'EN' };
  return translations[currentLanguage];
};
